export const videos =   [
    {
        tag: 'HMW',
        img: 'https://fdrive.in/onboardFleet/driverImages/img1.png',
        title: 'Road Safety',
        isWatched: false
    },
    {
        tag: 'PCW',
        img: 'https://fdrive.in/onboardFleet/driverImages/img2.png',
        title: 'Addictions',
        isWatched: false
    },
    {
        tag: 'DRS',
        img: 'https://fdrive.in/onboardFleet/driverImages/img3.png',
        title: 'Stress Management',
        isWatched: true
    },
    {
        tag: 'STR',
        img: 'https://fdrive.in/onboardFleet/driverImages/img4.png',
        title: 'Road Safety',
        isWatched: true
    },
    {
        tag: 'HB ',
        img: 'https://fdrive.in/onboardFleet/driverImages/img5.png',
        title: 'Addictions',
        isWatched: false
    },
    {
        tag: 'HA ',
        img: 'https://fdrive.in/onboardFleet/driverImages/img6.png',
        title: 'Stress Management',
        isWatched: false
    },
    {
        tag: 'HMW',
        img: 'https://fdrive.in/onboardFleet/driverImages/img7.png',
        title: 'Road Safety',
        isWatched: true
    },
    {
        tag: 'STR',
        img: 'https://fdrive.in/onboardFleet/driverImages/img8.png',
        title: 'Addictions',
        isWatched: false
    },
    {
        tag: 'HMW',
        img: 'https://fdrive.in/onboardFleet/driverImages/img9.png',
        title: 'Stress Management',
        isWatched: true
    },
    {
        tag: 'DRS',
        img: 'https://fdrive.in/onboardFleet/driverImages/img10.png',
        title: 'Road Safety',
        isWatched: false
    },
    {
        tag: 'STR',
        img: 'https://fdrive.in/onboardFleet/driverImages/img11.png',
        title: 'Addictions',
        isWatched: true
    },
    {
        tag: 'HB ',
        img: 'https://fdrive.in/onboardFleet/driverImages/img12.png',
        title: 'Stress Management',
        isWatched: true
    },
];
